<template>
  <div class="list-template" :class="active ? 'active' : 'deactive'">
    <div class="side">
      <div class="inside">
        <div class="side-slot">
          <slot name="side" />
        </div>
      </div>
    </div>
    <div class="main">
      <slot name="back-to-list" class="back-to-list" />
      <div class="main-scroll">
        <div class="inside">
          <slot name="main" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    selected: Object,
    active: Boolean,
  },
});
</script>

<style lang="scss" scoped>
.list-template {
  display: flex;
  @include mq(sp) {
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
}

.side {
  width: 250px;
  height: 100vh;

  @include mq(sp) {
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }

  .inside {
    height: 100%;

    @include mq(sp) {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  .side-slot {
    height: 100%;

    @include mq(sp) {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      /* スロットで挿入されたラッパー（例: CharactersPage の div）に高さを伝える */
      ::v-deep > * {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      /* ラッパー内のコンポーネント（CharacterList 等）のルートにも高さを伝える */
      ::v-deep > * > * {
        flex: 1;
        min-height: 0;
        overflow: hidden;
      }
    }
  }
}

.main-scroll {
  height: 100vh;
  display: flex;
  flex-direction: column;

  @include mq(sp) {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .inside {
    flex-grow: 1;
    overflow: auto;

    @include mq(sp) {
      flex: 1;
      min-height: 0;
      overflow: auto;
      /*
       * -webkit-overflow-scrolling: touch は iOS Safari で position: fixed の
       * z-index が正しく機能しない問題を引き起こすため削除
       * 現代の iOS Safari ではこのプロパティなしでもスムーズスクロールが有効
       */
    }
  }
}

.main {
  flex: 1;
  border-left: 1px solid var(--color-border);

  @include mq(sp) {
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
}

.deactive > .main {
  @include mq(sp) {
    display: none;
  }
}

.active > .side {
  @include mq(sp) {
    display: none;
  }
}

.back-to-list {
  @include mq(pc) {
    display: none;
  }
}

.deactive > .back-to-list {
  @include mq(sp) {
    display: none;
  }
}
</style>
